module.exports = __webpack_public_path__ + "static/media/cacophony.8096087d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/portfolio/thumbnails/cacophony.gif
// module id = 241
// module chunks = 0